'use client'

import { createContext, useContext } from 'react'

type PwaInstallContextValue = {
  runInstall: () => void
}

export const PwaInstallContext = createContext<PwaInstallContextValue | null>(null)

export function usePwaInstallAction() {
  return useContext(PwaInstallContext)
}
